// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iL-z","twoColumnImage":"jL-z"};